import {SmartSiteBaseApiV2} from "../SmartSiteBaseApiV2";

export class PersonTypeApi extends SmartSiteBaseApiV2 {

    public get ControllerName(): any {
        return 'personType';
    }
    
}